import { useEffect } from 'react'
import { usePocOperationalStatus } from '@/proxy/seller/hooks'
import { AllowedStatusSprinklrChat } from './enums/allowedStatusSprinklrChat'
import { SprinklrChatWidget } from './widget'
import { logger } from '@/monitoring/logger'

const Sprinklr = () => {
  const { data: { seller = {}, user = {} } = {} } = usePocOperationalStatus()

  useEffect(() => {
    const beforePrint = () => window?.sprChat && window.sprChat('disable')
    window.addEventListener('beforeprint', beforePrint)

    const afterPrint = () => window?.sprChat && window.sprChat('enable')
    window.addEventListener('afterprint', afterPrint)

    return () => {
      window.removeEventListener('beforeprint', beforePrint)
      window.removeEventListener('afterprint', afterPrint)
    }
  }, [])

  const canShowSprinklrChat =
    seller?.status in AllowedStatusSprinklrChat &&
    !window?.sprChatSettings?.user

  logger.info('canShowSprinklrChat', {
    sellerId: seller?.id,
    sellerStatus: seller?.status,
    allowedStatusSprinklrChat: seller?.status in AllowedStatusSprinklrChat,
    hasSprinklrSettings: !window?.sprChatSettings?.user,
    canShowSprinklrChat,
  })

  if (canShowSprinklrChat) {
    SprinklrChatWidget(seller, user)
  }

  return <></>
}

export default Sprinklr
